import React from 'react';
import { LuxuryHomesHome } from '@components';
import './style.scss';

const LuxuryHomesHomePage: React.FC = () => {
  return (
    <div className="luxury-homes-home-page">
      <LuxuryHomesHome />
    </div>
  );
}; 

export default LuxuryHomesHomePage; 